import ko from 'knockout';

ko.bindingHandlers['stopBinding'] = {
    init: function () {
    	return { controlsDescendantBindings: true };
    }
};

ko.virtualElements.allowedBindings.stopBinding = true;